import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'eo-max-length-counter-msg',
  templateUrl: './eo-max-length-counter-msg.component.html',
  styleUrl: './eo-max-length-counter-msg.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoMaxLengthCounterMsgComponent),
      multi: true,
    },
  ],
})
export class EoMaxLengthCounterMsgComponent {
  @Input() formControl?: FormControl<any> | undefined;

  private getMaxLengthFromValidator(fallback?: number): number | undefined {
    const validator = this.formControl?.validator;

    if (!validator) {
      return fallback;
    }

    const errors = validator(new FormControl({ length: Infinity }));
    return errors?.['maxlength']?.['requiredLength'] ?? fallback;
  }

  protected hasMaxLengthValidator(): boolean {
    return this.getMaxLengthFromValidator() != null;
  }

  protected getRemainingCharCount() {
    return this.getMaxLengthFromValidator()! - this.formControl?.value?.length;
  }

  protected showMaxLengthCounter() {
    return (
      this.hasMaxLengthValidator() &&
      this.getRemainingCharCount() >= 0 &&
      this.formControl?.value?.length > 0
    );
  }

    // implement ControlValueAccessor start ------------------
    writeValue(obj: any): void {}
    registerOnChange(fn: any): void {}
    registerOnTouched(fn: any): void {}
    // implement ControlValueAccessor end ------------------
}
